import { AddressesRepository } from '@lib/api/repository/addresses/addresses.repository';
import { Address, AddressInput, City, State } from '@lib/types';

import { Requester } from '../clients';

export default class AddressesAPI implements AddressesRepository {
  async list(signal?: AbortSignal) {
    return (await Requester.get<Address[]>('/addresses', { signal })).data;
  }

  async create(input: AddressInput) {
    return (await Requester.post<Address>('/addresses', { body: input })).data;
  }

  async update(id: string, input: AddressInput) {
    return (await Requester.patch<Address>(`/addresses/${id}`, { body: input }))
      .data;
  }

  async remove(id: string) {
    await Requester.delete(`/addresses/${id}`);
  }

  async listStates(signal?: AbortSignal) {
    return (await Requester.get<State[]>('/locations/states', { signal })).data;
  }

  async listCities(stateId: string, signal?: AbortSignal) {
    return (await Requester.get<City[]>(`/locations/states/${stateId}/cities`, { signal })).data;
  }
}
